import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const ButtonContainer = styled.div`
  width: 100%;

  display: flex;
  gap: 16px;

  ${mediaQueries.tablet} {
    width: auto;
  }
`
